<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'《新仙剑奇侠传之挥剑问情》手游下载'"></div>
    <div :class="'login-bank-page page-' + pageShow">
      <div class="login-main">
        <div class="qc-logo"><i></i></div>
        <div class="login-content">
          <div class="label-box account">
            <i></i>
            <label for="">
              <input 
                type="text" 
                placeholder="请输入青瓷帐号" 
                v-model="inputData.account"
              >
            </label>
          </div>
          <div class="label-box password">
            <i></i>
            <label for="">
              <input 
                :type="eyeShow" 
                placeholder="请输入密码" 
                v-model="inputData.password"
              >
            </label>
            <b :class="'eye-' + eyeShow" @click="eyeChange()"></b>
          </div>
          <div class="label-box captcha">
            <i></i>
            <label for="">
              <input 
                type="text" 
                placeholder="请输入图形验证码" 
                v-model="inputData.captcha"
              >
            </label>
            <strong @click="captchaImg()"><img :src="captchaUrl"></strong>
          </div>
          <div class="label-box btn">
            <a href="javascript:;" @click="goLogin()"></a>
          </div>
        </div>
      </div>
      <!-- 公共底部 -->
      <Footer/>
    </div>
    <!-- 提示弹窗 -->
    <div :class="'tips-wrap tips-wrap-' + tipsShow">
      <div :class="'show-' + tipsShow2"><p>{{ tips }}</p></div>
    </div>
  </div>

</template>
<script>
import Footer from '../../../../components/BankFooter';
import { Indicator } from 'mint-ui';
import { getRandomString, buriedLogger } from '@/utils/utils';
import { LoginAPI } from '../api';
import CryptoJS from "crypto-js";
export default {
  components: {
    Footer
  },
  data () {
    return {
      pageShow: false,
      eyeShow: 'password',
      inputData: {
        //  输入框内容
        account: '',
        password: '',
        captcha: ''
      },
      captchaUrl: '',
      cryptoPassword: '',
      // 提示弹窗
      tips: '', // 提示语
      tipsShow: false,  // 提示显示1
      tipsShow2: false, // 提示显示2
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.pageShowTimes();
      this.captchaImg();
      // this.localStorageData();
    })
    // 埋点
    const bl = buriedLogger('hjwq', 'bank_login_page');
    this.logger = bl;

    setTimeout(() => {
      this.logger.sum('银行挑战赛h5_账户登录页统计');
    }, 200);    
  },
  computed: {},
  methods: {
    pageShowTimes() {
      setTimeout(() => {
        this.pageShow = true;
      }, 200)
    },
    // 图片验证码
    captchaImg() {
      this.captchaUrl = `https://adminapi.qingcigame.com/captcha/login?r=${Math.random()}`;
    },
    // 密码可视是否开启
    eyeChange() {
      this.eyeShow === 'password' ? this.eyeShow = 'text' : this.eyeShow = 'password';
    },
    goLogin() {
      if (this.inputData.account == '') {
        return this.tipsMessage('青瓷账户不能为空', 2000);
      }
      if (this.inputData.password == '') {
        return this.tipsMessage('密码不能为空', 2000);
      }
      if (this.inputData.captcha == '') {
        return this.tipsMessage('验证码不能为空', 2000);
      }
      const utf8 = CryptoJS.enc.Utf8.parse(this.inputData.password)
      this.cryptoPassword = CryptoJS.enc.Base64.stringify(utf8)
      LoginAPI({
        account: this.inputData.account, 
        password: this.cryptoPassword,
        captcha: this.inputData.captcha
      }).then(response => {
        if (Number(response.code) == 200) {
          this.logger.sum('银行挑战赛h5_账户登录成功');
          Indicator.open();
          // localStorage.setItem('account', this.inputData.account);
          // localStorage.setItem('password', this.inputData.password);
          window.location.href = origin + `/hjwq/bank/enter${getRandomString()}`;
          return
        }
        this.tipsMessage(response.message, 2000);
        
      });
    },
    // 存储账号信息
    localStorageData() {
      if(localStorage.getItem('account') !== null) {
        this.inputData.account = localStorage.getItem('account');
        this.inputData.password = localStorage.getItem('password');
      }
    },
    // TAG: 其他简易封装的方法
    tipsMessage (message, times) {
      this.tipsShow = true
      this.tips = message
      setTimeout(() => { this.tipsShow2 = true }, 100)
      setTimeout(() => { this.tipsShow2 = false }, times - 200)
      setTimeout(() => { this.tipsShow = false; this.tips = '';}, times)
    },
  }
};
</script>

<style lang="less" scoped>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/bank/login/index.vue